const Joi = require("joi");
const ValidationTranslateFile = require("../../src/config/ValidationTranslateFile.jsx");
const currentLang = ValidationTranslateFile()

const inmateTransferFundSchema = (data, creditBalance) => {
  const schema = Joi.object({
    ToInmateID: Joi.required().not(null, '')
      .messages({
        "any.required": currentLang?.ValidationSchema?.Please_Choose_Inmate,
        "any.invalid": currentLang?.ValidationSchema?.Please_Choose_Inmate,
      }),

    TransferAmount: Joi.number()
      .greater(0)
      .max(!isNaN(creditBalance) ? creditBalance : 0)  // Ensure creditBalance is valid
      .required()
      .messages({
        "number.base": currentLang?.ValidationSchema?.Transfer_Amount_valid_number,
        "number.greater": currentLang?.ValidationSchema?.Transfer_Amount_Greater,
        "number.max": `${currentLang?.ValidationSchema?.Transfer_Amount_Cannot_Exceed} $${creditBalance}.`,
        "any.required": `${currentLang?.ValidationSchema?.Transfer_Amount_ShouldNot_Zero} $${creditBalance}.`,
      }),
  }).unknown(true);

  return schema.validate(data, { abortEarly: false });
};

module.exports = inmateTransferFundSchema;
